// Multi-source barcode identifier.
// 1. OpenFoodFacts (free, food-focused) — best for consumer packaged foods & beverages.
// 2. Gemini + Google Search (backend) — works for tobacco, cosmetics, household, electronics.
// 3. AI Vision (GPT via /api/ai/photo) — final fallback using the camera frame.
import api from "@/lib/api";
import { lookupBarcode } from "@/lib/lookupBarcode";

const dataUrlToBlob = async (dataUrl) => (await fetch(dataUrl)).blob();

export async function identifyProduct(barcodeText, frameDataUrl) {
  // 1) OpenFoodFacts (food/beverage DB)
  const off = await lookupBarcode(barcodeText);
  if (off?.name && !/^Barcode /i.test(off.name)) return { ...off, source: "off" };

  // 2) Gemini identifier (any consumer product — tobacco, cosmetics, household, etc.)
  try {
    const { data } = await api.post("/products/identify", { barcode: barcodeText });
    if (data?.product?.name) return { ...data.product, source: "gemini" };
  } catch { /* try next */ }

  // 3) AI Vision using the exact frame at detection time
  if (frameDataUrl) {
    try {
      const blob = await dataUrlToBlob(frameDataUrl);
      const fd = new FormData();
      fd.append("image", blob, "product.jpg");
      const { data } = await api.post("/ai/photo?preview=true", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const item = (data?.extracted || [])[0];
      if (item?.name) return { name: item.name, category: item.category || "groceries", source: "ai" };
    } catch { /* fall through */ }
  }

  // 4) Last resort — treat as unknown barcode
  return { name: `Barcode ${barcodeText}`, category: "groceries", source: "unknown" };
}
